module.exports = __webpack_public_path__ + "static/media/brasao_ssp.65f19b90.jpg";